import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore"


const firebaseConfig = {
  apiKey: "AIzaSyCq2mwj1eBCSUK6YuXSogcaFHtuK5lQgZs",
  authDomain: "goldy-portfolio.firebaseapp.com",
  projectId: "goldy-portfolio",
  storageBucket: "goldy-portfolio.firebasestorage.app",
  messagingSenderId: "183469553589",
  appId: "1:183469553589:web:e3560c117a137f84bd4bfc"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore()